Date.prototype.getWeekNumber = function(){
    var d = new Date(Date.UTC(this.getFullYear(), this.getMonth(), this.getDate()));
    var dayNum = d.getUTCDay() || 7;
    d.setUTCDate(d.getUTCDate() + 4 - dayNum);
    var yearStart = new Date(Date.UTC(d.getUTCFullYear(),0,1));
    return Math.ceil((((d - yearStart) / 86400000) + 1)/7)
};


// import * as Common from './common';
import './wakelock';
import Login from './login';
import moment from 'moment';
import datepicker from 'js-datepicker';
import jsSelector from './jsSelector';
import { OrdersManagerUtils } from './orders_manager_utils';

let oo = null;

// Keep ONLY truly global / lightweight modules here

async function init() {

    // Init login (usually needed globally)
    const login = new Login();

    const view = jsSelector.view();
    const type = jsSelector.type();
    

    // -------------------------
    // VIEW-BASED LAZY LOADING
    // -------------------------

    switch (view) {

        case "orders": {
            const { default: Orders } = await import('./orders');
            oo = new Orders();
            break;
        }
        case "clients": {
            const { default: Clients } = await import('./clients');
            oo = new Clients();
            break;
        }

        case "coupons": {
            const { default: Coupons } = await import('./coupons');
            oo = new Coupons();
            break;
        }

        case "suppliers": {
            const { default: Suppliers } = await import('./suppliers');
            oo = new Suppliers();
            break;
        }

        case "newsletter": {
            const { default: Newsletter } = await import('./newsletter');
            oo = new Newsletter();
            break;
        }

        case "shipping": {
            const { default: Shipping } = await import('./shipping');
            oo = new Shipping();
            break;
        }

        case "eventproductviews": {
            const { default: CustomEvents } = await import('./custom_events');
            oo = new CustomEvents();
            break;
        }

        // add more views here
    }

    // -------------------------
    // TYPE-BASED MODULES
    // -------------------------

    if (
        type === "tnt" ||
        type === "transactions" ||
        type === "coupons" ||
        type === "schools" ||
        type === "raccoltapunti" ||
        type === "blists"
    ) {
        new OrdersManagerUtils();
    }

    // -------------------------
    // UI INIT (lightweight only)
    // -------------------------

    $(".aggregation-level").html('(MONTH)');

    function setDates(start = null, end = null) {
        if (start) {
            $('#selected-date-start').html(start.format('MMM Do YY'));
            $('#selected-date-start-f').val(start.format());
        }

        if (end) {
            $('#selected-date-end').html(end.format('MMM Do YY'));
            $('#selected-date-end-f').val(end.format());
        }
    }

    // -------------------------
    // DATEPICKER (only if needed)
    // -------------------------

    const elementSExists = document.getElementById("reportrange-start");
    const elementEExists = document.getElementById("reportrange-end");

    let datestart, dateend;

    if (elementSExists || elementEExists) {

        const start = moment().subtract(2, 'years').startOf('year');
        const end = moment();

        setDates(start, end);

        if (elementSExists) {
            datestart = datepicker('#reportrange-start', {
                id: 1,
                onSelect: instance => {
                    setDates(moment(instance.dateSelected), null);
                    replot(datestart, dateend);
                },
                dateSelected: new Date(start.format('MMMM D, YYYY')),
                maxDate: new Date(2099, 0, 1),
                minDate: new Date(2017, 11, 1),
                showAllDates: true
            });
        }

        if (elementEExists) {
            dateend = datepicker('#reportrange-end', {
                id: 1,
                onSelect: instance => {
                    setDates(null, moment(instance.dateSelected));
                    replot(datestart, dateend);
                },
                dateSelected: new Date(),
                maxDate: new Date(2099, 0, 1),
                minDate: new Date(2017, 11, 1),
                showAllDates: true
            });
        }

        if (datestart && dateend) {
            replot(datestart, dateend);
        }
    }

    // -------------------------
    // OPTIONAL HOOKS
    // -------------------------

    if (oo && typeof oo.bindAggregate !== "undefined") {
        oo.bindAggregate();
    }
}

// -------------------------
// GLOBAL FUNCTIONS
// -------------------------

function replot(datestart, dateend) {
    if (!oo) return; // prevent crash

    let sdate_f = moment(datestart.getRange().start).format();
    let edate_f = moment(dateend.getRange().end).format();

    const daterange = { start: sdate_f, end: edate_f };

    const period = oo.setAllowedAggregationPeriod(daterange).default;

    oo.replotAll({ period, daterange });
}

// -------------------------
// START APP
// -------------------------

init();









